import { Check, Gem, Zap } from "lucide-react";
import { formatNumber } from "@/lib/format";
import { cn } from "@/lib/utils";

const OPTIONS = [
  { key: "budget", label: "Budget", icon: Zap, blurb: "Sharp everyday images, up to 2048 px" },
  { key: "premium", label: "Premium", icon: Gem, blurb: "Our finest detail, lighting and lettering, 2K" },
];

export function QualityPicker({ value, onChange, prices }) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2" role="radiogroup" aria-label="Quality" data-testid="quality-picker">
      {OPTIONS.map(({ key, label, icon: Icon, blurb }) => {
        const offer = prices?.[key];
        const active = value === key;
        return (
          <button key={key} type="button" role="radio" aria-checked={active} disabled={!offer?.available} onClick={() => onChange(key)}
            data-testid={`quality-${key}`}
            className={cn("group relative flex items-start gap-3 rounded-xl border p-3.5 text-left transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-40",
              active ? "border-white/40 bg-white/[0.07]" : "border-white/[0.08] bg-ink-900 hover:border-white/20")}>
            <span className={cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors", active ? "bg-white text-ink-950" : "bg-white/[0.06] text-zinc-300")}>
              <Icon className="h-4 w-4" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 text-sm font-medium text-zinc-100">
                {label}
                {active && <Check className="h-3.5 w-3.5 text-white" />}
              </span>
              <span className="mt-0.5 block text-xs text-zinc-500">{blurb}</span>
            </span>
            <span className="shrink-0 text-xs tabular-nums text-zinc-300" data-testid={`quality-${key}-credits`}>
              {offer?.available ? `${formatNumber(offer.credits)} cr` : "—"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
